import React from 'react';
import {Modal} from 'react-bootstrap';
import { PropTypes } from 'prop-types';
import FooterColores from './FooterColores';
import '../styles/site.css';

// Parametros props
//show: si se muestra o no el modal
//title: titulo del modal
//body: cuerpo del modal

  ModalCS.propTypes = {
    show: PropTypes.bool.isRequired,
    title: PropTypes.string.isRequired,
    size: PropTypes.string,
    body: PropTypes.object,
    class: PropTypes.string,
  };
  
  ModalCS.defaultProps = {  
    show: false,
    title: 'Default',
    body: <>Body</>,
    size: "md",
    handleClose: ()=>{ console.log("Ocultando o mostrando..")},
    class: 'tituloSeccion tituloModal',
  };
  
  function ModalCS(props) {
      
      return (<>
                <Modal show={props.show} size={props.size} onHide={props.handleClose}>
                  <Modal.Header className={props.class}>{props.title}</Modal.Header>
                  <Modal.Body>
                      <>{props.body}</>
                  </Modal.Body>
                  <Modal.Footer>
                      {<FooterColores></FooterColores>}
                  </Modal.Footer>
                </Modal>
              </>)
    }
  
  export default React.memo(ModalCS);